import { render, staticRenderFns } from "./DealMethods.vue?vue&type=template&id=6c8289c6&scoped=true"
import script from "./DealMethods.vue?vue&type=script&lang=js"
export * from "./DealMethods.vue?vue&type=script&lang=js"
import style0 from "./DealMethods.vue?vue&type=style&index=0&id=6c8289c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8289c6",
  null
  
)

export default component.exports